import React from 'react';
import { T } from '../../utils/theme';
import { Scissors, Users, CreditCard, BarChart3, Bell, Settings, X, LogOut, Wallet } from 'lucide-react';

const MORE_OPTIONS = [
  { icon: Scissors, label: 'Servicos', sub: 'Gerenciar catalogo', tint: T.accent, view: 'servicos' },
  { icon: Users, label: 'Barbeiros', sub: 'Equipe cadastrada', tint: T.purple, view: 'barbeiros' },
  { icon: Users, label: 'Usuarios', sub: 'Controle de acesso', tint: T.warning, view: 'usuarios' },
  { icon: CreditCard, label: 'Faturamento', sub: 'Plano e cobrancas', tint: T.success, view: 'faturamento' },
  { icon: BarChart3, label: 'Relatorios', sub: 'Vendas, comissoes, ranking', tint: T.pink, view: 'relatorios' },
  { icon: Wallet, label: 'Financeiro', sub: 'Caixa e despesas', tint: T.teal, view: 'financeiro' },
];

const SheetMais = ({ open, onClose, onNavigate, onLogout }) => (
  <>
    <div className={`sheet-backdrop ${open ? 'open' : ''}`} onClick={onClose} />
    <div className={`sheet-panel ${open ? 'open' : ''}`}>
      <div className="sheet-panel-inner">
        <div className="sheet-grabber" />
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '4px 6px 16px' }}>
          <div>
            <div style={{ fontSize: 24, fontWeight: 700, color: T.label, letterSpacing: '-0.025em' }}>Mais opcoes</div>
            <div style={{ fontSize: 13, color: T.label2, marginTop: 2 }}>Gerencie tudo em um so lugar</div>
          </div>
          <button onClick={onClose} style={{
            width: 32, height: 32, borderRadius: 16, border: 'none',
            background: T.fill, color: T.label, cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}><X size={18} strokeWidth={2.2} /></button>
        </div>

        <div style={{
          background: 'rgba(0,0,0,0.02)', borderRadius: 18,
          border: `0.5px solid ${T.separator}`, overflow: 'hidden',
        }}>
          {MORE_OPTIONS.map((opt, i) => (
            <button key={opt.view} onClick={() => { onNavigate(opt.view); onClose(); }} style={{
              width: '100%', textAlign: 'left', border: 'none', background: 'transparent',
              cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 12,
              padding: '13px 14px', fontFamily: 'inherit', color: T.label,
              borderBottom: i < MORE_OPTIONS.length - 1 ? `0.5px solid ${T.separator}` : 'none',
            }}>
              <div style={{
                width: 34, height: 34, borderRadius: 10,
                background: opt.tint + '22', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
              }}>
                <opt.icon size={19} color={opt.tint} strokeWidth={2} />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 15, fontWeight: 600, letterSpacing: '-0.01em' }}>{opt.label}</div>
                <div style={{ fontSize: 12, color: T.label2, marginTop: 1 }}>{opt.sub}</div>
              </div>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={T.label3} strokeWidth="1.8" strokeLinecap="round"><path d="M9 6l6 6-6 6"/></svg>
            </button>
          ))}
        </div>

        <button onClick={onLogout} style={{
          marginTop: 12, width: '100%', border: 'none',
          background: 'rgba(255,59,48,0.1)', color: T.danger,
          padding: '13px 16px', borderRadius: 16, fontFamily: 'inherit',
          fontSize: 15, fontWeight: 600, cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
          letterSpacing: '-0.01em',
        }}>
          <LogOut size={17} color={T.danger} strokeWidth={2} />
          Sair da conta
        </button>
      </div>
    </div>
  </>
);

export default SheetMais;
